export enum Language {
  en = 'en',
  de = 'de',
  da = 'da',
  es = 'es',
  fr = 'fr',
  it = 'it',
  nl = 'nl',
}
